<div class="container my-4">
  <h3 class="mb-3">Danh sách Phiếu Xuất Kho</h3>
  <div class="mb-3 d-flex align-items-center justify-content-between">
    <p class="text">
      <i class="text"></i> Nhấn "Xuất Excel cho tất cả PXK" để xuất toàn bộ hoặc
      nhấn nút
      tại từng phiếu để xuất riêng từng phiếu. File này có thể dùng để liên thông dữ liệu với CSDL Dược Quốc Gia
    </p>
    <div class="d-flex gap-2">
      <app-button (click)="downloadShipmentPDF()">
        <h6 class="text-white">Tải xuống phiếu xuất kho</h6>
      </app-button>

      <app-button (click)="exportExcel()">
        <h6 class="text-white">Xuất Excel cho tất cả PXK</h6>
      </app-button>
    </div>
  </div>
  <ng-container *ngFor="let row of shipments">
    <!-- Table riêng cho mỗi phiếu -->
    <div class="table-responsive">
      <table class="table table-bordered table-hover align-middle mb-4">
        <thead class="table-light">
          <tr>
            <th [attr.colspan]="hasDiscount(row.shipmentItems) ? 7 : 6">
              <div class="d-flex justify-content-between align-items-center">
                <span>Phiếu xuất kho: {{ row.shipmentCode }} | Ngày xuất: {{ row.shipmentDate | date:'dd-MM-yyyy' }} |
                  Số thùng: {{ row.boxCount }}</span>
                <app-button (click)="exportExcel(row.shipmentId)">
                  <h6 class="text-white">Xuất Excel</h6>
                </app-button>
              </div>
            </th>
          </tr>
          <tr>
            <th>Ảnh sản phẩm</th>
            <th>Tên sản phẩm</th>
            <th>Giá</th>
            <th *ngIf="hasDiscount(row.shipmentItems)">
              Giá sau chiết khấu
            </th>
            <th>Số lượng</th>
            <th>Số LOT</th>
            <th>Ngày hết hạn</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of row.shipmentItems">
            <td>
              <img [src]="getProductInfo(item.productSku)?.imageUrls?.[0]"
                alt="{{ getProductInfo(item.productSku)?.name }}" width="70" height="70" class="rounded me-2">
            </td>
            <td>
              <ng-container *ngIf="getProductInfo(item.productSku) as product; else skuOnly">
                <a [href]="product.slug ? '/product/' + product.slug : '/product/' + product.productID" target="_blank">
                  {{ product.name || item.productSku }}
                </a>
              </ng-container>
              <ng-template #skuOnly>
                {{ item.productSku }}
              </ng-template>
              <ng-container *ngIf="item.combo_ProductSku">
                <ng-container *ngIf="getProductInfo(item.combo_ProductSku) as product;">
                  <div>
                    <b>(Sản phẩm thuộc combo:&nbsp;
                      <a [href]="product.slug ? '/product/' + product.slug : '/product/' + product.productID"
                        target="_blank">
                        {{ product.name || item.productSku }}
                      </a>
                      )</b>
                  </div>
                </ng-container>
              </ng-container>
            </td>
            <td>{{ item.price | currencySymbol }}</td>
            <td *ngIf="hasDiscount(row.shipmentItems)">
              <ng-container *ngIf="item.priceUnitAfterDiscount">
                {{ item.priceUnitAfterDiscount | currencySymbol }}
              </ng-container>
            </td>
            <td>{{ item.quantity }}</td>
            <td>{{ item.lotNumber || '-' }}</td>
            <td>{{item.expiryDate | date:'dd-MM-yyyy'}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>
</div>